import { render, staticRenderFns } from "./HisInfoDepartmentSelectDialog.vue?vue&type=template&id=0edf1c3b&scoped=true&"
import script from "./HisInfoDepartmentSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./HisInfoDepartmentSelectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf1c3b",
  null
  
)

export default component.exports